export default "__VITE_ASSET__dbe16d56__"